module.exports = __webpack_public_path__ + "img/error-neck.67af1cd9.png";